(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const sliders = document.querySelectorAll('.card-product-slider');

        sliders.forEach((card) => {
            const productUrl = card.dataset.productUrl;
            if (!productUrl) return;

            const slider = card.querySelector('slideshow-component');
            const dots = slider.querySelectorAll('.slider-counter__link--dots');
            const slides = slider.querySelectorAll('.slider__slide img'); // Target images inside slides
            const sliderContainer = slider.querySelector('.slider');

            let currentActiveIndex = 0;
            let isDragging = false;
            let scrollTimeout;

            // Set first dot as active on page load
            if (dots.length > 0) {
                dots[0].classList.add('slider-counter__link--active');
            }

            // Function to update active dot when slider moves (Debounced)
            const updateActiveDot = () => {
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(() => {
                    let activeIndex = currentActiveIndex;

                    slides.forEach((slide, index) => {
                        const slideRect = slide.getBoundingClientRect();
                        const sliderRect = sliderContainer.getBoundingClientRect();

                        if (slideRect.left >= sliderRect.left && slideRect.right <= sliderRect.right) {
                            activeIndex = index;
                        }
                    });

                    if (activeIndex !== currentActiveIndex) {
                        currentActiveIndex = activeIndex;
                        dots.forEach((dot, index) => {
                            dot.classList.toggle('slider-counter__link--active', index === currentActiveIndex);
                        });
                    }
                }, 100);
            };

            // Click event for dots (Fixed flickering with 500ms delay)
            dots.forEach((dot, index) => {
                dot.setAttribute('data-slide-index', index);
                dot.addEventListener('click', (event) => {
                    event.preventDefault();
                    event.stopPropagation();

                    if (index !== currentActiveIndex) {
                        slides[index].scrollIntoView({
                            behavior: 'smooth',
                            inline: 'center',
                            block: 'nearest',
                        });

                        setTimeout(() => {
                            currentActiveIndex = index;
                            dots.forEach((d, i) => {
                                d.classList.toggle('slider-counter__link--active', i === currentActiveIndex);
                            });
                        }, 500);
                    }
                });
            });

            // Scroll event to update active dot while swiping
            sliderContainer.addEventListener('scroll', updateActiveDot);

            // Detect dragging/swiping to prevent unwanted clicks
            let startX, startY;
            slider.addEventListener('mousedown', (event) => {
                isDragging = false;
                startX = event.clientX;
                startY = event.clientY;
                slider.style.cursor = 'grabbing';
            });

            slider.addEventListener('mousemove', () => (isDragging = true));

            slider.addEventListener('mouseup', (event) => {
                slider.style.cursor = 'grab';
                if (isDragging) event.stopPropagation();
            });

            // Click event on images (navigate to product)
            slides.forEach((slide) => {
                slide.addEventListener('mouseenter', () => {
                    slide.style.cursor = 'pointer';
                });

                slide.addEventListener('click', (event) => {
                    if (!isDragging) {
                        if (event.ctrlKey || event.metaKey) {
                            window.open(productUrl, '_blank'); // Open in a new tab if Ctrl/Cmd is held
                        } else {
                            window.location.href = productUrl;
                        }
                    }
                });
            });

            // Prevent navigation when clicking on non-image slider elements
            slider.addEventListener('click', (event) => {
                if (event.target.closest('.slider-counter__link--dots, .slider-button') || isDragging) {
                    event.stopPropagation();
                }
            });

            // Main card click event (only navigates if clicked outside slider)
            card.addEventListener('mouseenter', () => {
                card.style.cursor = 'pointer';
            });

            card.addEventListener('click', function (event) {
                if (!event.target.closest('slideshow-component')) {
                    if (event.ctrlKey || event.metaKey) {
                        window.open(productUrl, '_blank'); // Open in a new tab if Ctrl/Cmd is held
                    } else {
                        window.location.href = productUrl;
                    }
                }
            });
        });
    });
})();